export default __webpack_public_path__ + "static/media/slide_01.5395aaf4.gif";